export default __webpack_public_path__ + "static/media/accordion_close.bc1cccb1.svg";